export default {
    description: 'Просто опиши, що саме тобі потрібно та отримуй пропозиції, серед яких обирай найкращу',
    description_One: 'Просто опиши, що саме тобі потрібно та отримуй',
    description_Two: 'пропозиції, серед яких обирай найкращу',
    createButton: 'Створити тендер',
    createButtonInfo: 'Всього 3 хвилини і готово',
    goAndTry: 'Перейти та спробувати',
}